@if (!readonly()) {
  <ui-button-group>
    <ui-button
      [loading]="isRemoveLoading()"
      [disabled]="isRemoveLoading()"
      (clicked)="edit.emit()"
      buttonStyle="tonal"
    >
      Bearbeiten
    </ui-button>

    <ui-button
      [loading]="isRemoveLoading()"
      [disabled]="isRemoveLoading()"
      (clicked)="remove.emit()"
      buttonStyle="tonal"
    >Löschen
    </ui-button>
  </ui-button-group>
}

@if (!product().prices?.redacted) {
  <div class="wrapper-bundle-price">
    <span class="bundle-price-label">Ihr Paket</span>
    <ui-product-prices-formatter class="bundle-price" [price]="product().prices?.bundlePrice ?? 0"></ui-product-prices-formatter>
  </div>
}
